import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';

import CenteredCircularProgress from '../../../../../../../../../lib/designSystem/CircularProgress';
import Uploader from '../../../../../../../../../lib/designSystem/Uploader';

import { checkSIIDocumentForUploadingInvoices } from '../../../../../../../../../lib/api/sii';

const AddInvoicesCSV = (props: any) => {
  const { business, setInvoices } = props;
  const dispatch = useDispatch();
  const [uploadedFileName, setUploadedFileName] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const handleFileChange = async (event: any) => {
    const uploadedFile = event.target.files[0];
    if (!uploadedFile) return;

    setUploadedFileName(uploadedFile.name);

    let parsedFile: any[] = [];

    if (uploadedFile.name.endsWith('.csv')) {
      console.log('Parseando CSV');
      parsedFile = await parseCSV(uploadedFile);
    } else if (
      uploadedFile.name.endsWith('.xlsx') ||
      uploadedFile.name.endsWith('.xls')
    ) {
      console.log('Parseando XLSX');
      parsedFile = await parseXLSX(uploadedFile);
    } else {
      alert('Formato de archivo no soportado. Solo .csv y .xlsx');
      return;
    }

    console.log('parsedFile', parsedFile);
    const formattedFile = formatedCSV(parsedFile);
    console.log('formattedFile', formattedFile);
    // await validateDocuments(formattedFile);
    await validateDocuments(formattedFile);
  };

  const formatedCSV = (parsedFile: any[]) => {
    return parsedFile.map((invoice: any) => {
      const code = invoice['Codigo'] ? invoice['Codigo'] : '33';
      return {
        folio: invoice.Folio,
        businessIdentifier: business.identifier,
        stakeholderName: invoice['Razon Social'],
        stakeholderIdentifier: invoice['Rut cliente'],
        issuedDate: invoice['Fecha Recepcion'],
        amount: invoice['Monto total'],
        type: code === '33' ? 'electronic-invoice' : 'electronic-invoice-exent',
      };
    });
  };

  const validateDocuments = async (invoices: any[]) => {
    try {
      setLoading(true);
      const newInvoices = invoices.map((invoice: any) => {
        const [yyyy, mm, dd] = invoice.issuedDate.split('/');
        const date = `${dd}${mm}${yyyy}`;
        return {
          ...invoice,
          issuedDate: date,
        };
      });
      const response = await checkSIIDocumentForUploadingInvoices(dispatch, {
        invoices: newInvoices,
      });

      console.log('response', response);

      if (response.length) {
        const failedInvoices = response.filter(
          (invoice: any) => !invoice.valid,
        );

        const validInvoicesFolios = response
          .filter((invoice: any) => invoice.valid)
          .map((invoice: any) => invoice.folio);

        const validInvoices = invoices.filter((invoice: any) =>
          validInvoicesFolios.includes(invoice.folio),
        );

        if (failedInvoices.length) {
          setInvoices(validInvoices);

          alert(
            `Los siguientes documentos no son válidos: ${failedInvoices
              .map((invoice: any) => invoice.folio)
              .join(', ')}`,
          );
          return false;
        } else {
          setInvoices(validInvoices);
          return true;
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const parseCSV = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => resolve(result.data),
        error: (error) => reject(error),
      });
    });
  };

  const parseXLSX = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array', cellDates: true });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const json = XLSX.utils.sheet_to_json(worksheet, {
          defval: '',
          raw: false, // permite que fechas se entreguen como strings si es posible
        });

        const parsed = json.map((row: any) => {
          const fechaRaw = row['Fecha Recepcion'];

          const parseFecha = (value: any) => {
            console.log('value', value);
            let [mm, dd, yyyy] = value.split('/');
            if (yyyy.length === 2) {
              yyyy = `20${yyyy}`;
            }
            const date = `${yyyy}/${mm}/${dd}`;
            return date;
          };

          return {
            ...row,
            'Fecha Recepcion': parseFecha(fechaRaw),
            'Monto total': row['Monto total'].split(',').join(''),
          };
        });
        console.log('parsed', parsed);

        resolve(parsed);
      };
      reader.onerror = (err) => reject(err);
      reader.readAsArrayBuffer(file);
    });
  };

  const downloadTemplate = () => {
    // build template data
    const template = [
      {
        Folio: '123',
        'Razon Social': 'Tech Spa',
        'Rut cliente': '11111111-1',
        'Fecha Recepcion': '01/01/21',
        'Monto total': '100000',
        Codigo: '33',
      },
    ];

    // build xlsx workbook
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(template);

    // build columns
    const columns = [
      [
        'Folio',
        'Razon Social',
        'Rut cliente',
        'Fecha Recepcion',
        'Monto total',
        'Codigo',
      ],
    ];
    XLSX.utils.sheet_add_aoa(worksheet, columns, { origin: 'A1' });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'template.xlsx');
  };

  if (loading) return <CenteredCircularProgress type="dialog" />;

  return (
    <div style={{ padding: '10px 0px' }}>
      {loading ? (
        <CenteredCircularProgress type="dialog" />
      ) : (
        <>
          <Typography variant="body1" style={{ paddingBottom: '10px' }}>
            Agrega el archivo xlsx con las facturas que quieres ingresar
          </Typography>
          <Uploader
            handleFileChange={handleFileChange}
            buttonText="Agregar XLSX"
            accept=".xlsx,.xls"
            uploadedFileName={uploadedFileName}
          />
          <Typography
            variant="body1"
            textAlign="center"
            style={{
              paddingTop: '10px',
              cursor: 'pointer',
              color: 'blue',
              fontWeight: 'bold',
            }}
            onClick={downloadTemplate}
          >
            Descargar template
          </Typography>
        </>
      )}
    </div>
  );
};

export default AddInvoicesCSV;
